
// Explicit React import at the top
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export const PressHeroSection = () => {
  const { language } = useLanguage();
  
  return (
    <section className="py-10 px-4 md:pt-12 md:pb-8">
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-balance">
          {language === 'fr' ? (
            <>
              📰 Espace Presse — Recut x StudioCanal
            </>
          ) : (
            <>
              📰 Press Room — Recut x StudioCanal
            </>
          )}
        </h1>
        
        <p className="text-lg md:text-xl font-medium text-muted-foreground mb-8">
          {language === 'fr' ? (
            "Le premier challenge créatif short form autour d'un film, 100 % légal et organique"
          ) : (
            "The first creative short form challenge around a film, 100% legal and organic"
          )}
        </p>
      </div>
    </section>
  );
};
